import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import FormBuilderSidebar from "../components/pageBuilder2/components/FormBuilderSidebar";
import FormsContainer from "../components/pageBuilder2/components/FormsContainer";
import { FormBuilderObjects } from "../variables/formBuilderData";
import FormInputConfig from "../components/pageBuilder2/components/FormInputConfig";
import Responsive from "../components/Responsive";
import { conditionalWidth, translate } from "../utils/useful";
import FormBuilderTopbar from "../components/pageBuilder2/components/FormBuilderTopbar";
import Sections from "../components/PageBuilderAT/SectionsContainer";
class PageBuilderAT extends Component {
    state = {
        sections: [
            {
                sectionId: uuidv4(),
                rowsInSection: [
                    {
                        rowId: uuidv4(),
                        isRowFullWidth: false,
                        columnsInRow: [
                            {
                                columnId: uuidv4(),
                                columnStyle: {
                                    width: 90,
                                    margin: 5
                                },
                                elementsInColumn: [
                                    {
                                        elementId: uuidv4(),
                                        elementStyle: {
                                            width: 100,
                                            minHeight: 20
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        count: 0,
        showhandlers: false,
        showStructures: false,
        elDragData: {}
    };

    addNewSection = () => {};

    setSectionRows = (sectionId, rowId, rowsNumber) => {
        console.log(sectionId, rowsNumber);
        let sections = [...this.state.pageSections];
        let foundSection = sections.find((sect) => sect.sectionId == sectionId);
        let foundRow = foundSection.formsRows.find((row) => row.rowId == rowId);
        console.log(sectionId, rowId);
        let newRow = {
            rowId: uuidv4(),
            rowColumns: []
        };
        let newColumn = {
            rowColumnId: uuidv4(),
            columnContent: []
        };
        let count = 1;
        while (count <= rowsNumber) {
            foundRow.rowColumns.push(newColumn);
            count = count + 1;
        }
        console.log(sections);
        this.setState({ pageSections: sections }, () =>
            console.log(this.state)
        );
    };

    addnewItem = (posObject, dragData, dropPosition) => {
        let body = [...this.state.body];
        switch (dragData.dropType) {
            case "NEW":
                let newItem = {
                    elementId: uuidv4(),
                    initialLeft: Number(posObject.leftPos),
                    initalWidth: Number(posObject.width),
                    minWidth: Number(posObject.minWidth),
                    elementType: dragData.type,
                    dropPosition
                };
                let newRow = {
                    isDynamic: false,
                    rowElements: [newItem],
                    rowId: uuidv4()
                };
                body.push(newRow);
                break;
            case "CHANGE":
                break;
            default:
                break;
        }
        this.setState({ body }, () => {});
    };

    changeElementsWidthDragOver = (rowId, dragData) => {
        let body = [...this.state.body];
        switch (dragData.dropType) {
            case "NEW":
                break;
            case "CHANGE":
                let sourceFoundRow = body.find(
                    (row) => row.rowId == dragData.rowId
                );
                let sourceFoundEl = sourceFoundRow.rowElements.find(
                    (el) => el.elementId == dragData.inputId
                );
                let desFoundRow = body.find((row) => row.rowId == rowId);
                let elementsWidth = desFoundRow.rowElements.map(
                    (el) => el.initalWidth
                );
                let maxWidth = Math.max(elementsWidth);
                let elWithMaxWidth = desFoundRow.rowElements.find(
                    (el) => el.initalWidth == maxWidth
                );
                let widthDifference =
                    elWithMaxWidth.initalWidth - sourceFoundEl.minWidth;
                // console.log(
                //     "elWithMaxWidth",
                //     elWithMaxWidth,
                //     "\n",
                //     dragData,
                //     "\n",
                //     sourceFoundEl
                // );

                if (widthDifference > elWithMaxWidth.minWidth) {
                    elWithMaxWidth.initalWidth =
                        elWithMaxWidth.initalWidth - sourceFoundEl.minWidth;
                    console.log("INITAAAAAL", elWithMaxWidth.initalWidth);
                }

                this.setState(
                    {
                        body
                    },
                    () => {
                        console.log("BODY AFTER CHAGNE", this.state.body);
                    }
                );
                break;
            default:
                break;
        }

        // console.log("sourceFoundRow", sourceFoundRow);
        // console.log("sourceFoundEl", sourceFoundEl);
        // console.log("desFoundRow", desFoundRow);
    };

    changeElementWidth = (rowId, elementId, finalChange) => {
        console.log(rowId, elementId);
        let body = [...this.state.body];
        let foundRow = body.find((row) => row.rowId == rowId);
        let foundEl = foundRow.rowElements.find(
            (ele) => ele.itemId == elementId
        );
        console.log("CHANGE TIME", finalChange);
        foundEl.initalWidth = finalChange;
        this.setState({ body });
        // console.log(foundRow,foundEl, newWidth);
    };

    addGhostElementOnDragOver = (DropZone, sectionId, otherArgs) => {
        let elDragData = this.state.elDragData;
        console.log(elDragData, "DRAAAGEDATAAA");
        // the minWidth will be defined according to the dragged element and eldragdata which will be added later on to the element object
        let sections = [...this.state.sections];
        let currentSection = sections.find(
            (sect) => sect.sectionId == sectionId
        );

        let newElementId = uuidv4();
        let newElement = {
            elementId: newElementId,
            elementStyle: {}
        };
        let newColumnId = uuidv4();
        let newColumn = {
            columnId: newColumnId,
            elementsInColumn: [],
            columnStyle: {}
        };
        let newRowId = uuidv4();
        let newRow = {
            rowId: newRowId,
            isRowFullWidth: false,
            columnsInRow: []
        };
        let newSectionId = uuidv4();
        let newSection = {
            sectionId: newSectionId,
            rowsInSection: []
        };
        
        console.log("INSDE FUNCTION", DropZone);
        switch (elDragData.dropType) {
            case "NEW":
                switch (DropZone) {
                    // elements style will be defined based on eldragedata; for now, a static object is given.
                    case "ON_LEFT_SIDE":
                        // newElement.elementStyle.minHeight = 20;
                        // newElement.elementStyle.width = 100;
                        // newColumn.elementsInColumn.push(newElement);
                        // newColumn.columnStyle.width = 100;
                        // newColumn.columnStyle.margin = 0;
                        // newColumn.elementsInColumn.push(newElement);
                        // newRow.columnsInRow.push(newColumn);
                        // currentSection.rowsInSection.push(newRow);
                        // console.log("IS ON ROW SIDES", this.state.isOnRowSides,);
                        
                        //     !this.state.isOnRowSides &&   this.setState({ sections, [DropZone]: newRowId }, () => {
                        //         console.log('IN THE CALLBACK')
                        //     });

                        break;
                    case "ON_MIDDLE_SIDE":
                        break;

                    case "ON_RIGHT_SIDE":
                        break;
                    case "ON_ROW_LEFT_SIDE":
                        // console.log("ON ROOOOOOOOOOOOOOOOOOW");
                        // newElement.elementStyle.minHeight = 20;
                        // newElement.elementStyle.width = 100;

                        // newColumn.elementsInColumn.push(newElement);
                        // newColumn.columnStyle.width = 100;
                        // newColumn.columnStyle.margin = 0;

                        // newColumn.elementsInColumn.push(newElement);
                        // newRow.columnsInRow.push(newColumn);
                        // currentSection.rowsInSection.push(newRow);
                        
                        //     this.setState({
                        //         sections,
                        //         [DropZone]: newRowId,
                        //         isOnRowSides: true
                        //     });
                        break;
                    case "ON_ROW_MIDDLE_SIDE":
                        break;
                    case "ON_ROW_RIGHT_SIDE":
                        break;
                    case "COLUMN":
                        // console.log("ON COLUMN");
                        // newElement.elementStyle.minHeight = 20;
                        // newElement.elementStyle.width = 100;
                        // newColumn.elementsInColumn.push(newElement);
                        // newColumn.columnStyle.width = 100;
                        // newColumn.columnStyle.margin = 0;
                        // newColumn.elementsInColumn.push(newElement);
                        // newRow.columnsInRow.push(newColumn);
                        // currentSection.rowsInSection.push(newRow);
                        //     this.setState({
                        //         sections,
                        //         [DropZone]: newRowId,
                        //         isOnRowSides: true
                        //     });
                        break;
                }
                break;
        }
    };
    removeGhostElementOnDragLeave = (DropZone, sectionId, otherArgs) => {
        let elDragData = this.state.elDragData;
        let sections = [...this.state.sections];
        let currentSection = sections.find(
            (sect) => sect.sectionId == sectionId
        );
        // the minWidth will be defined according to the dragged element and eldragdata which will be added later on to the element object

        // console.log("INSDE FUNCTION", DropZone);

        switch (DropZone) {
            case "ON_LEFT_SIDE":
                // let draggedOverRowId = this.state[DropZone];
                // console.log("SECTIONSSS START");
                // // let newRowList = currentSection.rowsInSection.filter(
                // //     (row) => row.rowId != draggedOverRowId
                // // );
                // let rowIndex = currentSection.rowsInSection
                //     .map((x) => {
                //         return x.Id;
                //     })
                //     .indexOf(draggedOverRowId);
                // currentSection.rowsInSection.splice(rowIndex, 1);
                // console.log(draggedOverRowId, currentSection);
                // this.setState({ sections });
                break;
            case "ON_MIDDLE_SIDE":
                break;

            case "ON_RIGHT_SIDE":
                break;
            case "ON_ROW_LEFT_SIDE":
                break;
            case "ON_ROW_MIDDLE_SIDE":
                break;
            case "ON_ROW_RIGHT_SIDE":
                break;
            case "ON_EXISTING_COLUMN":
                break;
        }
    };

    changeInputPosition = (
        inputId,
        sectionId,
        rowId,
        type,
        rowID,
        direction,
        inputIndex
    ) => {
        let pageSections = [...this.state.pageSections];
        let foundSection = pageSections.find(
            (sect) => sect.sectionId == sectionId
        );
        let formsRows = foundSection.formsRows;

        let foundRow = formsRows.find((row) => row.rowId == rowId);

        let destinationRow = formsRows.find((row) => row.rowId == rowID);
        let destinationRowIndex = formsRows.indexOf(destinationRow);

        let foundInput = foundRow.rowContent.find(
            (input) => input.id == inputId
        );

        let foundInputIndex = foundRow.rowContent.indexOf(foundInput);
        foundRow.rowContent.splice(foundInputIndex, 1);
        let foundRowIndex = formsRows.indexOf(foundRow);

        // destinationRow.rowContent.splice()
        let newRowInput = foundInput;

        let newRow = {
            rowId: uuidv4(),
            rowContent: []
        };

        switch (direction) {
            case "top":
                if (foundRowIndex == destinationRowIndex) return;
                if (foundRow.rowContent.length == 0) {
                    formsRows.splice(foundRowIndex, 1);
                }
                newRow.rowContent.push(newRowInput);
                formsRows.unshift(newRow);
                break;
            case "bottom":
                if (foundRow.rowContent.length == 0) {
                    newRow.rowContent.push(foundInput);
                    formsRows.splice(foundRowIndex, 1);
                    formsRows.splice(destinationRowIndex, 0, newRow);
                } else {
                    newRow.rowContent.push(foundInput);
                    formsRows.splice(destinationRowIndex + 1, 0, newRow);
                }
                break;

            case "left":
                destinationRow.rowContent.unshift(foundInput);

                if (foundRow.rowContent.length == 0) {
                    formsRows.splice(foundRowIndex, 1);
                }
                break;
            case "right":
                destinationRow.rowContent.splice(inputIndex + 1, 0, foundInput);
                if (foundRow.rowContent.length == 0) {
                    formsRows.splice(foundRowIndex, 1);
                }
                break;
            default:
                break;
        }

        this.setState({ formsRows }, () => {});
    };

    deleteInput = (inputId, sectionId, rowid) => {
        let pageSections = [...this.state.pageSections];
        let foundSection = pageSections.find(
            (sect) => sect.sectionId == sectionId
        );
        let formsRows = foundSection.formsRows;
        //
        let foundRow = formsRows.find((row) => row.rowId == rowid);
        let foundRowIndex = formsRows.indexOf(foundRow);
        let inputIndex = formsRows[foundRowIndex].rowContent.indexOf(
            foundRow.rowContent.find((input) => input.id == inputId)
        );

        let removedHeader = formsRows[foundRowIndex].rowContent[inputIndex];

        formsRows[foundRowIndex].rowContent.splice(inputIndex, 1);

        if (foundRow.rowContent.length == 0) {
            formsRows.splice(foundRowIndex, 1);
        }
        let newRow = {
            rowId: uuidv4(),
            rowContent: []
        };
        if (formsRows.length == 0) {
            formsRows.push(newRow);
        }
        //
        this.setState({ formsRows }, () => {});

        if (removedHeader.key == this.state.currentData?.key) {
            this.openInputConfig(null);
        }
    };

    openInputConfig = (header) => {
        //

        if (this.FormInputConfig) {
            this.FormInputConfig.validateForm((isvalid) => {
                if (!isvalid) {
                    return;
                }
                this.openInputConfigAct(header);
            });
        } else {
            this.openInputConfigAct(header);
        }
    };

    openInputConfigAct(header) {
        let sideOpen = header != null ? true : false;

        if (sideOpen && header && FormBuilderObjects[header.type]) {
            let data = null;

            this.state.formsRows.forEach((row) => {
                row.rowContent.forEach((input) => {
                    if (input.key == header.key) {
                        data = { ...input };
                    }
                });
            });
            this.setState(
                {
                    sideOpen,
                    currentInput: FormBuilderObjects[header.type],
                    currentData: data,
                    showConfig: false
                },
                () => {
                    this.setState({ showConfig: true });
                }
            );
        } else {
            this.setState(
                { sideOpen: false, currentInput: null, showConfig: false },
                () => {
                    this.setState({ showConfig: true });
                }
            );
        }
    }

    updateInputData = (key, value) => {
        let data = this.state.currentData;
        data.information[key] = value;
        this.setState({ currentData: data });
    };

    render() {
        const { pageSections, formItems, showhandlers } = this.state;
        return (
            <div
                ref={(el) => (this.formBuilder = el)}
                className={
                    "form-container bg-white h-100 " +
                    conditionalWidth(this.props.width, {
                        xs: " d-block  ",
                        md: " d-flex "
                    })
                }
            >
                <div
                    className={
                        "h-100 " +
                        conditionalWidth(this.props.width, {
                            xs: " d-none  ",
                            md: ""
                        })
                    }
                >
                    <Responsive
                        width={this.props.width}
                        height={"100%"}
                        media={{ xs: "none", sm: "none", md: "200px" }}
                    >
                        <FormBuilderSidebar
                            formItems={Object.values(FormBuilderObjects)}
                            setShowStructures={() =>
                                this.setState({
                                    showStructures: !this.state.showStructures
                                })
                            }
                            setElDragData={(elDragData) =>
                                this.setState({ elDragData })
                            }
                        />
                    </Responsive>
                </div>

                <div
                    className={
                        "position-sticky w-100 " +
                        conditionalWidth(this.props.width, {
                            xs: "",
                            md: " d-none "
                        })
                    }
                    style={{ top: 0, zIndex: 1 }}
                >
                    <FormBuilderTopbar
                        formItems={Object.values(FormBuilderObjects)}
                        showhandlers={() =>
                            this.setState({ showhandlers: true })
                        }
                        hideHandlers={() =>
                            this.setState({ showhandlers: false })
                        }
                    />
                </div>

                <div
                    className={
                        "sidePanel blur-back " +
                        conditionalWidth(this.props.width, {
                            xs: "",
                            lg: " d-none "
                        }) +
                        " " +
                        (this.state.sideOpen ? "" : "sideClose")
                    }
                    style={{
                        width: conditionalWidth(this.props.width, {
                            xs: "80%",
                            md: "200px"
                        })
                    }}
                >
                    {this.state.showConfig && (
                        <FormInputConfig
                            ref={(el) => (this.FormInputConfig = el)}
                            updateInputData={this.updateInputData}
                            headers={this.state.currentInput?.headers}
                            initData={this.state.currentData?.information}
                            input={this.state.currentInput}
                        />
                    )}
                    <button
                        className={"close-hide sideHandler blur-back flexcc "}
                        onClick={(e) => this.openInputConfig(null)}
                    >
                        <img src="/images/next-2.png" width="20px" alt="" />
                    </button>
                </div>

                <Responsive
                    width={this.props.width}
                    height={conditionalWidth(this.props.width, {
                        xs: "calc(100% - 80px)",
                        md: "100%"
                    })}
                    media={{ xs: "12", md: "12", lg: "8", xl: "8" }}
                >
                    <Sections
                        sections={this.state.sections}
                        showStructures={this.state.showStructures}
                        addnewItem={this.addnewItem}
                        changeElementWidth={this.changeElementWidth}
                        changeElementsWidthDragOver={
                            this.changeElementsWidthDragOver
                        }
                        elDragData={this.state.elDragData}
                        setElDragData={(elDragData) =>
                            this.setState({ elDragData })
                        }
                        addGhostElementOnDragOver={
                            this.addGhostElementOnDragOver
                        }
                        removeGhostElementOnDragLeave={
                            this.removeGhostElementOnDragLeave
                        }
                    />
                </Responsive>

                {/* <Responsive
                    width={this.props.width}
                    height={"100%"}
                    media={{ xs: "none", lg: "4", xl: "4" }}
                >
                    <div
                        className="w-100 w-100 h-100 scroll-no-scrollbar px-2"
                        style={{ boxShadow: "0px 0px 10px #00000010" }}
                    >
                        {this.state.currentInput && this.state.showConfig ? (
                            <FormInputConfig
                                ref={(el) => (this.FormInputConfig1 = el)}
                                updateInputData={this.updateInputData}
                                headers={this.state.currentInput?.headers}
                                initData={this.state.currentData?.information}
                                input={this.state.currentInput}
                            />
                        ) : (
                            <div className="flexcc flex-column py-5">
                                <img
                                    src="/assets/icons/useful/empty.png"
                                    height={70}
                                />
                                <p className="mt-3 text-semibold text-semibig">
                                    {translate("No Input is selected")}
                                </p>
                                <p
                                    className="mt-1 text-small color-gray-2 text-center"
                                    style={{ maxWidth: 200 }}
                                >
                                    {translate(
                                        "Select an input to customize it's information"
                                    )}
                                </p>
                            </div>
                        )}
                    </div>
                </Responsive> */}
            </div>
        );
    }
}

export default PageBuilderAT;
